import styles from './WelcomeJourneyStrip.module.css';

function CheckIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
    );
}

const DONE_STEPS = ['You joined TB2', 'Clinician approved your plan', 'Medication delivered'];

function WelcomeJourneyStrip() {
    return (
        <section className={styles.journey} data-screen-label="Your journey">
            <div className={styles.journeyInner}>
                <div className={styles.journeyLabel}>Your journey so far</div>
                <div className={styles.jrow}>
                    {DONE_STEPS.map((label) => (
                        <div className={`${styles.js} ${styles.done}`} key={label}>
                            <div className={styles.dot}><CheckIcon /></div>
                            <div className={styles.t}>{label}</div>
                        </div>
                    ))}
                    <div className={`${styles.js} ${styles.now}`}>
                        <div className={styles.dot}></div>
                        <div className={styles.t}>First dose &amp; check-ins<span className={styles.tag}>You are here</span></div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default WelcomeJourneyStrip;
